import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Fonts } from '@projectK/constants';
import PropTypes from 'prop-types';
import { IonButton } from '@ionic/react';
import { useMobileSettings } from '@projectK/context/MobileContextProvider';

const FilterModal = ({
  modalContent,
  title,
  clearFilter,
  isOpen,
  onClose,
  companyTheme,
}) => {
  const { mobileMode } = useMobileSettings();
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      fullWidth
      maxWidth='sm'
      className='filter_modal'
    >
      <DialogTitle>
        <Grid
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            width: 1,
            justifyContent: 'space-between',
          }}
        >
          <Typography
            variant='h4'
            sx={{
              color: companyTheme?.primary?.main || 'text.primary',
              fontWeight: Fonts.SEMI_BOLD,
            }}
          >
            {title}
          </Typography>
          <IonButton
            fill='outline'
            color='primary'
            mode={mobileMode}
            style={{
              borderColor: companyTheme?.primary?.main || '#2196f3',
              color: companyTheme?.primary?.main || '#2196f3',
            }}
            onClick={clearFilter}
          >
            Clear Filter
          </IonButton>
          <IconButton
            size='small'
            sx={{ fontWeight: 'bold' }}
            className='icon-btn '
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        </Grid>
      </DialogTitle>
      <DialogContent>{modalContent}</DialogContent>
    </Dialog>
  );
};
export default FilterModal;

FilterModal.propTypes = {
  modalContent: PropTypes.string,
  title: PropTypes.string,
  clearFilter: PropTypes.func,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  companyTheme: PropTypes.object,
};
